import {
  InitOverrideFunction,
  LogoReadModel,
  WhitelabelApi,
  WhitelabelGetLogoRequest,
  WhitelabelGetTranslationsRequest,
  WhitelabelResetLogoToDefaultPutRequest,
  WhitelabelResetSettingToDefaultPutRequest,
  WhitelabelSettingReadModel,
  WhitelabelUpdateLogoPutRequest,
  WhitelabelUpdateSettingPutRequest,
} from "../../../@api";

export class WhitelabelApiService implements Omit<
  WhitelabelApi,
  `${string}Raw` | "withMiddleware" | "withPreMiddleware" | "withPostMiddleware"
> {
  constructor(private readonly api: WhitelabelApi) {}

  public async whitelabelGetLogo(
    requestParameters: WhitelabelGetLogoRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<Blob> {
    return this.api.whitelabelGetLogo(requestParameters, initOverrides);
  }

  public async whitelabelGetLogos(
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<{ [key: string]: LogoReadModel }> {
    return this.api.whitelabelGetLogos(initOverrides);
  }

  public async whitelabelUpdateLogoPut(
    requestParameters: WhitelabelUpdateLogoPutRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<void> {
    return this.api.whitelabelUpdateLogoPut(requestParameters, initOverrides);
  }

  public async whitelabelResetLogoToDefaultPut(
    requestParameters: WhitelabelResetLogoToDefaultPutRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<void> {
    return this.api.whitelabelResetLogoToDefaultPut(requestParameters, initOverrides);
  }

  public async whitelabelGetSettings(
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<Array<WhitelabelSettingReadModel>> {
    return this.api.whitelabelGetSettings(initOverrides);
  }

  public async whitelabelGetTranslations(
    requestParameters: WhitelabelGetTranslationsRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<Blob> {
    return this.api.whitelabelGetTranslations(requestParameters, initOverrides);
  }

  public async whitelabelUpdateSettingPut(
    requestParameters?: WhitelabelUpdateSettingPutRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<void> {
    return this.api.whitelabelUpdateSettingPut(requestParameters, initOverrides);
  }

  public async whitelabelResetAllSettingsToDefaultPut(
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<void> {
    return this.api.whitelabelResetAllSettingsToDefaultPut(initOverrides);
  }

  public async whitelabelResetSettingToDefaultPut(
    requestParameters: WhitelabelResetSettingToDefaultPutRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<void> {
    return this.api.whitelabelResetSettingToDefaultPut(requestParameters, initOverrides);
  }
}
